import {Observable} from 'rxjs/Observable';
import {ReservationStayPreferencesDao} from '../daos/reservation-stay-preferences.dao';
import {Reservation} from '../model/reservation/reservation.model';
import {Injectable} from '@angular/core';
import {LogService} from './logging.service';
import {ReservationStayPreferences} from '../model/reservation/stay-preferences/reservation-stay-preferences.model';
import {ReservationStayPreferencesBuilder} from './builders/reservation-stay-preferences.builder';
import {StayPreferenceRequestBuilder} from './builders/stay-preference-request.builder';
import {ServiceError} from '../model/errors/service-error.model';
import {ServiceErrorMapper} from './mapper/service-error.mapper';
import {BaseService} from './base.service';

const RESERVATION_STAY_PREFERENCES_DURATION = 10 * 60 * 1000; // 10 minutes
const CLASS_NAME = 'ReservationStayPreferencesService';

@Injectable()
export class ReservationStayPreferencesService extends BaseService <ReservationStayPreferences, Reservation> {
  private _reservationStayPreferencesObservables: Map<string, Observable<ReservationStayPreferences>>;
  private _mobileApp: boolean = false;

  constructor(private _stayPreferencesDao: ReservationStayPreferencesDao, private _log: LogService) {
    super(new ServiceErrorMapper(), RESERVATION_STAY_PREFERENCES_DURATION);
    this._reservationStayPreferencesObservables = new Map<string, Observable<ReservationStayPreferences>>();
  }

  getReservationStayPreferences(reservation: Reservation, mobileApp: boolean = false, useCache: boolean = false): Observable<ReservationStayPreferences> {
    this._mobileApp = mobileApp;
    return this.getByKey(reservation, useCache);
  }

  protected getFreshObservable(reservation: Reservation): Observable<ReservationStayPreferences> {
    return this._stayPreferencesDao.get(reservation.confirmationNumber, reservation.originalSellDate, reservation.hotelMnemonic, this._mobileApp)
    .map((reservationStayPreferencesData) => {
      return new ReservationStayPreferencesBuilder().withStayPreferecesData(reservationStayPreferencesData).build();
    }).catch((error) => {
      const serviceError: ServiceError = this.mapError(error);
      this._log.error(`Error when getting reservation stay preferences ${reservation.confirmationNumber}`, CLASS_NAME, serviceError);
      return Observable.throw(serviceError);
    });
  }

  setReservationStayPreferences(reservation: Reservation, reservationStayPreferences: ReservationStayPreferences): Observable<ReservationStayPreferences> {
    const reservationStayPreferencesObservable:  Observable<ReservationStayPreferences> =  this._setReservationStayPreferences(reservation, reservationStayPreferences);
    return this.updateFreshObservable(reservation, reservationStayPreferencesObservable)
  }
  private _setReservationStayPreferences(reservation: Reservation, reservationStayPreferences: ReservationStayPreferences): Observable<ReservationStayPreferences> {
    const stayPreferenceClassic: Object = new StayPreferenceRequestBuilder()
      .withPreferences(reservationStayPreferences)
      .build();
    return this._stayPreferencesDao.put(reservation.confirmationNumber, reservation.originalSellDate, reservation.hotelMnemonic, stayPreferenceClassic, this._mobileApp)
      .map((reservationStayPreferencesData) => {
        return reservationStayPreferences;
      }).catch((error) => {
        const serviceError: ServiceError = this.mapError(error);
        this._log.error(`Error when setting reservation stay preferences ${reservation.confirmationNumber}`, CLASS_NAME, serviceError);
        return Observable.throw(serviceError);
      });
  }

  protected generateKey(reservation: Reservation): string {
    return [reservation.confirmationNumber, reservation.guest.lastName].join('-');
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/reservation-stay-preferences.service.ts